import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconFileListTimesOutline: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16667 16.0417H5C3.68583 16.0417 3.125 15.4808 3.125 14.1667V4.16666C3.125 2.85249 3.68583 2.29166 5 2.29166H9.375V4.16666C9.375 6.18166 10.485 7.29166 12.5 7.29166H14.375V9.16666C14.375 9.51166 14.655 9.79166 15 9.79166C15.345 9.79166 15.625 9.51166 15.625 9.16666V6.66666C15.625 6.50082 15.5592 6.34166 15.4417 6.22499L10.4417 1.22499C10.3242 1.10749 10.1658 1.04166 10 1.04166H5C2.985 1.04166 1.875 2.15166 1.875 4.16666V14.1667C1.875 16.1817 2.985 17.2917 5 17.2917H9.16667C9.51167 17.2917 9.79167 17.0117 9.79167 16.6667C9.79167 16.3217 9.51167 16.0417 9.16667 16.0417ZM10.625 4.16666V3.17583L13.4908 6.04166H12.5C11.1858 6.04166 10.625 5.48082 10.625 4.16666ZM15 11.0417C12.8175 11.0417 11.0417 12.8175 11.0417 15C11.0417 17.1825 12.8175 18.9583 15 18.9583C17.1825 18.9583 18.9583 17.1825 18.9583 15C18.9583 12.8175 17.1825 11.0417 15 11.0417ZM15 17.7083C13.5067 17.7083 12.2917 16.4933 12.2917 15C12.2917 13.5067 13.5067 12.2917 15 12.2917C16.4933 12.2917 17.7083 13.5067 17.7083 15C17.7083 16.4933 16.4933 17.7083 15 17.7083ZM6.45833 9.16666C6.45833 9.51166 6.17833 9.79166 5.83333 9.79166C5.48833 9.79166 5.20833 9.51166 5.20833 9.16666C5.20833 8.82166 5.48833 8.54166 5.83333 8.54166C6.17833 8.54166 6.45833 8.82166 6.45833 9.16666ZM6.45833 12.5C6.45833 12.845 6.17833 13.125 5.83333 13.125C5.48833 13.125 5.20833 12.845 5.20833 12.5C5.20833 12.155 5.48833 11.875 5.83333 11.875C6.17833 11.875 6.45833 12.155 6.45833 12.5ZM11.6667 8.54166C12.0117 8.54166 12.2917 8.82166 12.2917 9.16666C12.2917 9.51166 12.0117 9.79166 11.6667 9.79166H7.91667C7.57167 9.79166 7.29167 9.51166 7.29167 9.16666C7.29167 8.82166 7.57167 8.54166 7.91667 8.54166H11.6667ZM9.79167 12.5C9.79167 12.845 9.51167 13.125 9.16667 13.125H7.91667C7.57167 13.125 7.29167 12.845 7.29167 12.5C7.29167 12.155 7.57167 11.875 7.91667 11.875H9.16667C9.51167 11.875 9.79167 12.155 9.79167 12.5Z"
      fill={color}
    />
    <path
      d="M13.9583 13.9583L16.0417 16.0417M16.0417 13.9583L13.9583 16.0417"
      stroke={color}
      strokeWidth={1.25}
      strokeLinecap="round"
    />
  </svg>
);

export default IconFileListTimesOutline;
